import axios, { AxiosError } from "axios";
import { UseQueryResult, useQuery } from "react-query";
import { StrapiMessageTypeResponse } from "./types";

export const StrapiCMSApiService = async (
  path: string,
  id?: number,
  populate?: string
): Promise<StrapiMessageTypeResponse> => {
  const uri = `${process.env.REACT_APP_STRAPI_API_URL}/api/${path}${
    id ? `/${id}` : ""
  }?_limit=-1${populate ? `&populate${populate}` : ""}`;
  const { data } = await axios.get(uri, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`,
    },
  });
  return data;
};

const useMessageTemplates = (): UseQueryResult<
  StrapiMessageTypeResponse,
  AxiosError
> =>
  useQuery<
    Promise<StrapiMessageTypeResponse>,
    AxiosError,
    StrapiMessageTypeResponse
  >(["MessageTemplates"], () => StrapiCMSApiService("message-templates"));

export { useMessageTemplates };
